import { Component, effect, isSignal, signal, ViewChild, ViewContainerRef, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface CarouselItemConfig {
  key?: string;
  data?: CarouselItemData;
}

export interface CarouselItemData {
  component: any;
  componentRef: any;
  data?: any;
}

export interface HasDataSignal<T = any> {
  data: WritableSignal<T>;
}

function hasDataSignal<T = any>(instance: unknown): instance is HasDataSignal<T> {
  return !!instance
    && typeof instance === 'object'
    && 'data' in instance
    && isSignal((instance as any).data);
}

@Component({
    selector: 'bw-carousel-item-legacy',
    imports: [CommonModule],
    templateUrl: './carousel-item.component.html',
    styleUrl: './carousel-item.component.scss'
})
export class CarouselItemComponentLegacy {

  @ViewChild('carouselItem', { read: ViewContainerRef, static: true }) carouselItem!: ViewContainerRef;

  _component = signal<CarouselItemData | undefined>(undefined);
  component = this._component.asReadonly();

  constructor() {
    effect(() => {
      const componentConfig = this.component();
      if (componentConfig) {
        const componentRef = this.carouselItem.createComponent(componentConfig.componentRef);
        if (componentConfig.data && hasDataSignal(componentRef.instance)) {
          componentRef.instance.data.set(componentConfig.data);
        }
      }
    }, { allowSignalWrites: true });
  }

}
